




















































import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue'; //
import { ServicioProxy } from '@/config/enums'; //
import config from '@/config/index'; //
import { ComponenteBaseStepper } from '../../views/base/ComponenteBaseStepper';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import HandleErrors from '@/config/handleErrors';
import { LoadingService } from '@/services/loadingService';
// import Validadores from '@/config/validaRut';
import router from '../../router';
import { Validator } from 'vee-validate';
import ContactoEjecutivoForm from '@/views/auth/ContactoEjecutivoForm.vue';
const { AgGridVue } = require('ag-grid-vue'); //
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import { fetchContactoEjecutivo } from '@/views/auth/fetchContactoEjecutivo';
import { Snotify } from '@/snotify/Snotify';

@Component({
  components: {
    ContactoEjecutivoForm,
  },
})
export default class ContactoEjecutivo extends Vue {
  //variables globales
  btnText: string = 'Aceptar';
  btnClass: string = 'btn-aceptar';
  btnColor: string = '#ffe800';

  @Prop({ default: false }) show: boolean;

  //propiedades
  dialog: boolean = false;
  lstContactoEjecutivo: any = {};

  dictionaryFormErrors: any = {};
  handleErrors: HandleErrors = new HandleErrors();
  show1: boolean = false;

  ContactoEjecutivo: boolean = false;
  loadingService = new LoadingService();
  modoVer: boolean = true;

  redireccionaAceptarInfo: string = '0';
  hayContacto: boolean = true;

  mounted() {}

  @Watch('show')
  onPropertyChanged(value: boolean, oldValue: boolean) {
    this.btnText = 'Aceptar';
    this.btnClass = 'btn-aceptar';
    this.dialog = value;
    this.show1 = false;
    this.buscarContactoEjecutivo();
  }

  closeModal(val: boolean) {
    val = false;
    this.show1 = false;
    this.$emit('modalContactoEjecutivoEmit', false);
    this.dialog = false;
  }

  readonly $snotify: Snotify;

  fetchContactoEjecutivo() {
    this.loadingService.showLoading();
    return fetchContactoEjecutivo()
      .catch(error => {
        if (error.response.status != 404) {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los Contactos Ejecutivos',
            { timeout: 3000 }
          );
        }
      })
      .finally(() => this.loadingService.hideLoading());
  }

  async buscarContactoEjecutivo() {
    this.lstContactoEjecutivo = (await this.fetchContactoEjecutivo()) || [];
    if (this.lstContactoEjecutivo === []) {
      this.hayContacto = false;
    } else {
      this.hayContacto = true;
    }
  }
}
